// Locale-aware Link wrapper. Auto-prefixes /en when in English mode.

import { Link, type LinkProps } from "@tanstack/react-router";
import { useLocale, localeHref } from "@/lib/i18n";
import { forwardRef } from "react";

type Props = Omit<LinkProps, "to" | "params"> & {
  to: string;
  params?: Record<string, string>;
  className?: string;
  children?: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  "aria-label"?: string;
  title?: string;
};

export const LocaleLink = forwardRef<HTMLAnchorElement, Props>(function LocaleLink(
  { to, params, ...rest },
  ref,
) {
  const locale = useLocale();
  let href = to;
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      href = href.replace(`$${k}`, encodeURIComponent(v));
    }
  }
  const finalHref = localeHref(locale, href);
  // Cast to any: we deliberately bypass route-tree string type-checking because
  // we generate URLs from string templates at runtime.
  const LinkAny = Link as unknown as React.ComponentType<Record<string, unknown>>;
  return <LinkAny ref={ref} to={finalHref} {...rest} />;
});
